import { invalidateTicketCountsCache } from '@/lib/api'

/** Сайдбар и настройки подписываются на это событие после изменения списка проектов. */
export const PROJECTS_CHANGED_EVENT = 'sd-projects-changed'

export function notifyProjectsChanged(): void {
  window.dispatchEvent(new Event(PROJECTS_CHANGED_EVENT))
}

/** Перезапрос счётчиков в сайдбаре (в т.ч. `emergency_mode_active` и пункт «Авария»). */
export const TICKET_COUNTS_STALE_EVENT = 'sd-ticket-counts-stale'

export function notifyTicketCountsStale(): void {
  invalidateTicketCountsCache()
  window.dispatchEvent(new Event(TICKET_COUNTS_STALE_EVENT))
}

/**
 * Изменились тикеты (карточка, другая вкладка): обновить счётчики и список обращений без F5.
 * CustomEvent — в этой вкладке; `localStorage` — синхронизация с другими вкладками браузера.
 */
export const TICKETS_LIST_STALE_EVENT = 'sd-tickets-list-stale'

export const TICKETS_LIST_INVALIDATE_STORAGE_KEY = 'sd_tickets_list_invalidate'

export function notifyTicketsWorkspaceStale(): void {
  notifyTicketCountsStale()
  try {
    window.dispatchEvent(new Event(TICKETS_LIST_STALE_EVENT))
    localStorage.setItem(TICKETS_LIST_INVALIDATE_STORAGE_KEY, String(Date.now()))
  } catch {
    /* ignore */
  }
}
